/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * Safe deep merge for theme objects.
 * Unlike deepmerge (used by MT internally), this does NOT recurse into
 * React elements or arrays — avoids infinite recursion with React 19's
 * Symbol(react.transitional.element).
 */
export function mergeTheme(target: any, source: any): any {
  const result = { ...target };
  for (const key of Object.keys(source)) {
    const s = source[key];
    const t = target[key];
    if (
      s != null &&
      typeof s === 'object' &&
      !Array.isArray(s) &&
      t != null &&
      typeof t === 'object' &&
      !Array.isArray(t)
    ) {
      result[key] = mergeTheme(t, s);
    } else {
      result[key] = s;
    }
  }
  return result;
}
/* eslint-enable @typescript-eslint/no-explicit-any */
